import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { LoginModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(LoginModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));
